module.exports = __webpack_public_path__ + "img/invoice-de-female-banner-be.5c57804f.png";